<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_settle_planet')
}

const isOnMap = computed(() => {
  return route.path.startsWith('/map')
})

const goToMap = () => {
  router.push('/map')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/colonizing.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.colonizing.intro.haveColonizers') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.colonizing.intro.notFast') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.colonizing.intro.mapHelp') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info">
        <div class="ml-3">
          <ul class="list-decimal">
            <li>{{ t('tutorial.colonizing.settle.findHomeworld') }}</li>
            <li>{{ t('tutorial.colonizing.settle.clickName') }}</li>
            <li>{{ t('tutorial.colonizing.settle.findColonizer') }}</li>
            <li><i18n-t keypath="tutorial.colonizing.settle.selectSettle" tag="span"><template #icon><GenericIcon type="cmd_settle"/></template></i18n-t></li>
            <li>{{ t('tutorial.colonizing.settle.findPlanet') }}</li>
            <li>{{ t('tutorial.colonizing.settle.selectSet') }}</li>
          </ul>
        </div>
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnMap" @click="goToMap" class="mr-2">
        {{ t('common.actions.gotoMap') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.colonizing.settlersOnWay') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>